import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col w-full mtop-10" }
const _hoisted_2 = { class: "row w-full es-main-settings" }
const _hoisted_3 = { class: "mright-04 w-full" }
const _hoisted_4 = { class: "main-m w-full" }
const _hoisted_5 = { class: "col row justify-end w-full" }
const _hoisted_6 = {
  key: 0,
  class: "row w-full es-main-settings mtop-15"
}
const _hoisted_7 = { class: "mright-04 w-full" }
const _hoisted_8 = { class: "main-m w-full" }
const _hoisted_9 = { class: "col row justify-end" }
const _hoisted_10 = {
  key: 1,
  class: "row w-full es-main-settings mtop-15"
}
const _hoisted_11 = { class: "mright-04 w-full" }
const _hoisted_12 = { class: "main-m w-full" }
const _hoisted_13 = { class: "col row justify-end" }
const _hoisted_14 = {
  key: 2,
  class: "row w-full es-main-settings mtop-15 gap-04"
}
const _hoisted_15 = { class: "flex-2" }
const _hoisted_16 = { class: "main-m w-full" }
const _hoisted_17 = { class: "col row justify-end flex-1" }
const _hoisted_18 = { class: "col w-full mtop-15" }
const _hoisted_19 = { class: "margin-h3" }
const _hoisted_20 = {
  key: 0,
  class: "row w-full mtop-15"
}
const _hoisted_21 = {
  key: 1,
  class: "col gap-04 w-full"
}
const _hoisted_22 = { class: "w-full mright-04" }
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 2,
  class: "row w-full mtop-15"
}

import { CalendarSettingsPermissionEnum, PersonLightResponse, PlanningPermissionResponse, SettingsApi } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { nextTick, ref, watch, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { ApiError, ItemSelect } from '@/models/share.model';
import { Textarea, useToast } from 'primevue';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import { DURATION_VALUES } from '@/models/share.model';
import { useAppUserStore } from '@/stores/appUser';
import SharedService from '@/services/SharedService';
import SelectButton from 'primevue/selectbutton';
import { PInputNumber } from "@/config/primevue";


export default /*@__PURE__*/_defineComponent({
  __name: 'esCalendarMainSettings',
  props: {
    selectedInstitute: {},
    selectedHealthPro: {}
  },
  emits: ['setDuration', 'refresh-calendar'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();
const toast = useToast();
const appUserStore = useAppUserStore();

const settingsApi = new SettingsApi(medServerApiConfig);

const planningPermissions = ref<PlanningPermissionResponse[]>([]);
const duration = ref(0);
const backupDuration = ref(0);
const loadingPermission = ref<boolean>(false);
const beforeDay = ref<number>(null);
const cancelHour = ref<number>(null);
const generalMessage = ref<string>('');
const backupBeforeDay = ref<number>(null);
const backupCancelHour = ref<number>(null);
const backupGeneralMessage = ref<string>('');

const accessSettingsOptions = ref<string[]>([
  CalendarSettingsPermissionEnum.Access,
  CalendarSettingsPermissionEnum.Admin
]);

const durationOptions = DURATION_VALUES.map(value => ({
  label: t('settings.menu.duration', { numberMin: value }),
  value
}));

const currentPersonId = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return appUserStore.currentAppUserData.healthGroupMemberships[0].pwr.personWithRoleId
});

const getPortalModuleAccess = computed(():boolean => {
  return appUserStore.getPortalModuleAccess();
})

const emits = __emit;

// initial fetch
nextTick(async () => await getBaseAppointmentDuration())

async function getBaseAppointmentDuration() {
  if (props.selectedInstitute && (currentPersonId.value || props.selectedHealthPro?.id)) {
    await settingsApi.getGeneralPlanningSettingsByInstitute({instituteId: props.selectedInstitute.id, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value}).then((response) => {
      duration.value = response.baseAppointmentDurationInMinutes;
      beforeDay.value = response.beforeDay;
      cancelHour.value = response.cancelHour;
      generalMessage.value = response.appointmentGeneralMessage;
      backupDuration.value = duration.value;
      backupCancelHour.value = cancelHour.value;
      backupBeforeDay.value = beforeDay.value;
      backupGeneralMessage.value = generalMessage.value;
      emits('setDuration', backupDuration.value);
    })
  }
}

const updateBaseAppointmentDuration = async () => {
  if (duration.value && (currentPersonId.value || props.selectedHealthPro?.id)) {
    await settingsApi.setAppointmentBaseDurationByInstitute({
      appointmentBaseDurationRequest: {baseAppointmentDurationInMinutes: duration.value},
      instituteId: props.selectedInstitute.id,
      doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value
    }).then((response) => {
      duration.value = response.baseAppointmentDurationInMinutes;
      backupDuration.value = duration.value;
      emits('setDuration', backupDuration.value);
      emits('refresh-calendar');
      toastSuccess(toast, {
          summary: t('common.toast.success.update'),
          detail:  t('settings.label.main.duration.success.update')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
          summary: t('common.toast.error'),
          detail: error.status ? t('error.' + error.status) : t('common.toast.error')
      });
    });
  }
}

const updateBeforeDay = async (newValueBeforeDay: number) => {
  if (newValueBeforeDay != backupBeforeDay.value && (currentPersonId.value || props.selectedHealthPro?.id) && props.selectedInstitute?.id) {
    await settingsApi.setBeforeDayByInstitute({
      instituteId: props.selectedInstitute.id,
      doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value,
      beforeDayRequest: {
        beforeDay: newValueBeforeDay
      }
    }).then((response) => {
      beforeDay.value = response.beforeDay; 
      backupBeforeDay.value = beforeDay.value;
      toastSuccess(toast, {
          summary: t('common.toast.success.update'),
          detail:  t('settings.label.main.beforeDay.success.update')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
          summary: t('common.toast.error'),
          detail: error.status ? t('error.' + error.status) : t('common.toast.error')
      });
    });
  }
}

const updateCancelHour = async (newValueCancelHour: number) => {
  if (newValueCancelHour != backupCancelHour.value && (currentPersonId.value || props.selectedHealthPro?.id) && props.selectedInstitute?.id) {
    await settingsApi.setCancelHourByInstitute({
      instituteId: props.selectedInstitute.id,
      doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value,
      cancelHourRequest: {
        cancelHour: newValueCancelHour
      }
    }).then((response) => {
      cancelHour.value = response.cancelHour; 
      backupCancelHour.value = cancelHour.value;
      toastSuccess(toast, {
          summary: t('common.toast.success.update'),
          detail:  t('settings.label.main.cancelHour.success.update')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
          summary: t('common.toast.error'),
          detail: error.status ? t('error.' + error.status) : t('common.toast.error')
      });
    });
  }
}

const updateGeneralMessage = async () => {
  if (generalMessage.value != backupGeneralMessage.value && (currentPersonId.value || props.selectedHealthPro?.id) && props.selectedInstitute?.id) {
    await settingsApi.setAppointmentGeneralMessageByInstitute({
      instituteId: props.selectedInstitute.id,
      doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value,
      appointmentGeneralMessageRequest: {
        generalMessage: generalMessage.value
      }
    }).then((response) => {
      generalMessage.value = response.appointmentGeneralMessage; 
      backupGeneralMessage.value = generalMessage.value;
      toastSuccess(toast, {
          summary: t('common.toast.success.update'),
          detail:  t('settings.label.main.generalMessage.success.update')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
          summary: t('common.toast.error'),
          detail: error.status ? t('error.' + error.status) : t('common.toast.error')
      });
    });
  }
}

const getPlanningpermission = async () => {
  if (props.selectedInstitute && (currentPersonId.value || props.selectedHealthPro?.id)) {
    loadingPermission.value = true;
    settingsApi.getPlanningPermissionsByInstitute({instituteId: props.selectedInstitute.id, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value}).then((response: PlanningPermissionResponse[]) => {
        planningPermissions.value = response;
    }).catch((error: ApiError) => {
      toastError(toast, {
          summary: t('common.toast.error'),
          detail: error.status ? t('error.' + error.status) : t('common.toast.error')
      });
    }).finally(() => {
      loadingPermission.value = false;
    });
  }
}

const checkPermissionSelected = (valueToCheck: CalendarSettingsPermissionEnum, permissionSelected: CalendarSettingsPermissionEnum[]): boolean => {
  return permissionSelected?.some((item) => item === valueToCheck);
};

const getIcon = (value: CalendarSettingsPermissionEnum) => {
  return SharedService.getIcon(CalendarSettingsPermissionEnum.Access === value.toLowerCase() ? 'eye' : 'pencil_fill', false, 'shareIcons');
}

const changeAccessPermission = (accessValue: CalendarSettingsPermissionEnum[], permission: PlanningPermissionResponse) => {
  if (permission?.id && props.selectedInstitute) {

    const planningPermissionRequest = {
      access: accessValue
    };
    settingsApi.updatePlanningPermission({instituteId: props.selectedInstitute.id, planningPermissionId: permission.id, planningPermissionRequest: planningPermissionRequest})
      .then(async () => {
        toastSuccess(toast, {
          summary: t('common.toast.success.update'),
          detail: t('settings.label.main.permissions.message.success.update')
        });
        await getPlanningpermission();
      }).catch((error: ApiError) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: error.status ? t('error.' + error.status) : t('common.toast.error')
        });
      });
  }
}

// refresh on institute selection change
watch(
  ()=> props.selectedInstitute, 
  async  () => {
    await getBaseAppointmentDuration();
    await getPlanningpermission();
  }
);

watch(
  ()=> props.selectedHealthPro, 
  async  () => {
    await getBaseAppointmentDuration();
    await getPlanningpermission();
  }
);

watch(
    () => duration.value,
  async () => {
    if (duration.value !== backupDuration.value) {
        updateBaseAppointmentDuration();
    }
  }
);

onMounted(async () => {
  await getBaseAppointmentDuration();
  await getPlanningpermission();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('settings.label.main.duration.label')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(SelectButton), {
          modelValue: duration.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((duration).value = $event)),
          options: _unref(durationOptions),
          optionLabel: "label",
          optionValue: "value",
          class: "w-auto",
          allowEmpty: false
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    (getPortalModuleAccess.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('settings.label.main.beforeDay.label')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(PInputNumber), {
              modelValue: beforeDay.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((beforeDay).value = $event)),
              min: 0,
              size: "small",
              showButtons: "",
              required: "",
              onValueChange: _cache[2] || (_cache[2] = ($event: any) => (updateBeforeDay($event)))
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (getPortalModuleAccess.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('settings.label.main.cancelHour.label')), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_unref(PInputNumber), {
              modelValue: cancelHour.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cancelHour).value = $event)),
              min: 0,
              size: "small",
              showButtons: "",
              required: "",
              onValueChange: _cache[4] || (_cache[4] = ($event: any) => (updateCancelHour($event)))
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (getPortalModuleAccess.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('settings.label.main.generalMessage.label')), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_unref(Textarea), {
              modelValue: generalMessage.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((generalMessage).value = $event)),
              invalid: generalMessage.value?.length >= 500,
              size: "small",
              autoResize: "",
              class: "w-full",
              onBlur: updateGeneralMessage
            }, null, 8, ["modelValue", "invalid"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("h3", _hoisted_19, _toDisplayString(_unref(t)('settings.label.main.permissions.title')), 1),
      (loadingPermission.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(t)('settings.label.main.permissions.loading')), 1))
        : (planningPermissions.value && planningPermissions.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planningPermissions.value, (permission) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row-space-between w-full es-main-settings mtop-10",
                  key: permission.id
                }, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(permission.name), 1),
                  _createVNode(_unref(SelectButton), {
                    modelValue: permission.access,
                    "onUpdate:modelValue": ($event: any) => ((permission.access) = $event),
                    options: accessSettingsOptions.value,
                    multiple: "",
                    "aria-labelledby": "custom",
                    ref_for: true,
                    ref: permission.id,
                    onChange: ($event: any) => (changeAccessPermission($event.value, permission))
                  }, {
                    option: _withCtx((slotProps) => [
                      _createElementVNode("img", {
                        src: getIcon(slotProps.option),
                        class: _normalizeClass({'img-white': checkPermissionSelected(slotProps.option, permission.access)})
                      }, null, 10, _hoisted_23),
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('settings.label.main.permissions.' + slotProps.option.toLowerCase())), 1)
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(t)('settings.label.main.permissions.empty')), 1))
    ])
  ]))
}
}

})